
import React, { useEffect, useState } from 'react';
import ApiService from 'services';
import { Table, Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import TCABreadCrumb from 'components/breadcrumb';
import { getTeamLink } from 'utils/links';

function getIndex(index) {
    return index + 1;
}
export default function AllTeams() {

    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await ApiService.getTeams();
                setData(response);
                //console.log(response);
            } catch (error) {
                // Handle error
            }
        };

        fetchData();
    }, []);
    const breadCrumbData = [
        {
            title: "All Teams",

        }
    ];
    return (
        <div>
            <Row>
                <Col>
                    <TCABreadCrumb breadCrumbData={breadCrumbData} />
                    <h1>Teams</h1>
                </Col>
            </Row>

            <Row>
                <Col>
                    <span className='fs-5'>Filters: </span>
                    <div>
                        <Form.Check
                            inline
                            label="Show Current Tournament Teams"
                            name="group1"
                            type="check"
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Team Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.filter(function (element) {
                                return element.Status == 1;
                            }).sort(function (a, b) {
                                // return a negative number if a < b, 0 if a == b, or a positive number if a > b
                                return (a.TeamName == b.TeamName ? 0 : (a.TeamName < b.TeamName ? -1 : 1))
                            }).map((oneTeam, index) => {
                                return <tr key={index}>
                                    <td>{getIndex(index)}.</td>
                                    <td>{getTeamLink(oneTeam.TeamName, oneTeam.TeamId)}</td>
                                </tr>
                            })}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    );
}